import React from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import Link from '../Link';
import { linkType, colourThemeType } from '../../propTypes';
import {
  getSliceClickthroughBanner1,
  getSliceClickthroughBanner2,
  getSliceColourTheme,
  getSliceHidden,
} from '../../selectors';
import { sliceColourTheme } from '../../styles/theme';
import style from './styleKeyCalloutBanner';

const CalloutLink = ({ link, classes }) => {
  if (link && link.text) {
    return (
      <div className={classes.container}>
        <Link link={link} className={classes.link} />
      </div>
    );
  }
  return null;
};

CalloutLink.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  link: linkType,
};

CalloutLink.defaultProps = {
  link: undefined,
};

const KeyCalloutBanner = ({
  className, classes, link1, link2,
}) => (
  <div className={cn(className, classes.container)}>
    <CalloutLink
      link={link1}
      classes={{ container: classes.calloutContainer, link: classes.calloutLink }}
    />
    <CalloutLink
      link={link2}
      classes={{ container: classes.calloutContainer, link: classes.calloutLink }}
    />
  </div>
);

export const defaultColourTheme = sliceColourTheme.grey;

KeyCalloutBanner.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
  link1: linkType,
  link2: linkType,
  // eslint-disable-next-line react/no-unused-prop-types -- used in the styles
  colourTheme: colourThemeType,
  // eslint-disable-next-line react/no-unused-prop-types -- used in the styles
  hidden: PropTypes.bool,
};

KeyCalloutBanner.defaultProps = {
  className: undefined,
  link1: undefined,
  link2: undefined,
  colourTheme: defaultColourTheme,
  hidden: false,
};

const mapStateToProps = (state, { sliceId }) => ({
  colourTheme: sliceColourTheme[getSliceColourTheme(state, sliceId)],
  link1: getSliceClickthroughBanner1(state, sliceId),
  link2: getSliceClickthroughBanner2(state, sliceId),
  hidden: getSliceHidden(state, sliceId),
});

export default compose(
  connect(mapStateToProps),
  injectSheet(style),
)(KeyCalloutBanner);
